import { loader } from 'graphql.macro'

export default async function createCustomerInvoice ({ dataLoaders, variables }) {
  const schema = loader('./createCustomerInvoice.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { invoiceID: variables.invoiceID })
  return response.createCustomerInvoice
}
